// extracted by mini-css-extract-plugin
export default {"sliderContainer":"CoursesCarousel_sliderContainer__dLEKm"};